module.exports = __webpack_public_path__ + "static/media/i-breadcrumb-grey.167c5fd8.svg";